<button class="plus-btn btn_green" (click)="onPress()">
    <mat-icon class="white-icon" aria-hidden="false" aria-label="Plus Icon">add</mat-icon>
</button>
